import { createContext } from 'react';

export const StickyTabsContext = createContext<{
  onChangeStickyItem: (data: StickyTabsContextChangeOption) => void;
  onDestroyStickyItem: (data: { stickyKey: string }) => void;
  onChangeTabsSticky: (data: { height: number }) => void;
  stickyItemRefresh?: number;
} | null>(null);

export type StickyTabsContextChangeOption = {
  minOffsetTop: number;
  maxOffsetTop: number;
  stickyKey: string;
};
